<template>
  <v-card
    max-width="1200"
    class="mx-auto pa-0"
    :loading="loading"
    :disabled="loading"
  >
    <v-toolbar color="primary">
      <v-toolbar-title>
        <h1>{{ $t("info.system") }}</h1>
      </v-toolbar-title>
    </v-toolbar>

    <v-container class="pa-0 pa-sm-3 pa-xl-6" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="6" :order="$vuetify.display.smAndDown ? 2 : ''">
          <v-card max-width="500" class="mx-auto mb-5" color="grey-lighten-4">
            <v-card-title class="text-center mt-3">
              {{ $t("login.prestudent_authen_title") }}
            </v-card-title>
            <v-card-subtitle class="text-center">
              {{ $t("login.prestudent_authen_text") }}
            </v-card-subtitle>
            <v-form ref="form" v-model="valid" @submit.prevent="">
              <v-card-text>
                <v-text-field
                  label="Register/Apply ID"
                  v-model="username"
                  type="text"
                  :rules="usernameRules"
                  required
                ></v-text-field>
                <v-text-field
                  label="Password"
                  v-model="password"
                  type="password"
                  :rules="passwordRules"
                  required
                ></v-text-field>
                <router-link to="/request_password">
                  <p class="text-right">
                    {{ $t("request_password.title") }}
                  </p>
                </router-link>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  class="mx-auto mb-3"
                  type="submit"
                  color="primary"
                  variant="flat"
                  elevation="2"
                  :disabled="!valid"
                  @click="login()"
                >
                  {{ $t("app_bar.login") }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>

          <v-expansion-panels class="card-box mx-auto mb-3">
            <v-expansion-panel>
              <v-expansion-panel-title>
                {{ $t("login.officer_student_authen") }}
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-card
                  max-width="500"
                  class="rounded-0 mx-auto"
                  elevation="0"
                  color="grey-lighten-4"
                >
                  <v-card-actions>
                    <v-btn
                      class="mx-auto"
                      color="primary"
                      variant="flat"
                      elevation="2"
                      @click="loginKeycloak()"
                    >
                      {{ $t("app_bar.login") }}
                    </v-btn>
                  </v-card-actions>

                  <!--<v-card-title class="text-center mt-3">
                    {{ $t("login.google_authen_title") }}
                  </v-card-title>
                  <v-card-subtitle class="text-center">
                    {{ $t("login.google_authen_text") }}
                  </v-card-subtitle>
                  <v-card-actions>
                    <v-btn
                      class="mx-auto mb-3"
                      color="white"
                      variant="flat"
                      elevation="2"
                      :href="googleAuthenUrl"
                    >
                      <img src="images/google_logo.png" class="mr-1 google_logo" />
                      Login
                    </v-btn>
                  </v-card-actions>
                </v-card>

                <div v-if="!is_dev_env || true" class="separator">หรือ</div>

                <v-card
                  max-width="500"
                  class="rounded-0 mx-auto"
                  elevation="0"
                  color="grey-lighten-4"
                >
                  <v-card-title class="text-center mt-3">
                    {{ $t("login.university_authen_title") }}
                  </v-card-title>
                  <v-card-subtitle class="text-center">
                    {{ $t("login.university_authen_text") }}
                  </v-card-subtitle>
                  <v-form ref="form" v-model="officerValid" @submit.prevent="">
                    <v-card-text>
                      <v-text-field
                        label="Username (e.g. kmi.tl, kmi.tl@kmitl.ac.th)"
                        v-model="officerEmail"
                        type="text"
                        :rules="officerEmailRules"
                        required
                      ></v-text-field>
                      <v-text-field
                        label="Password"
                        v-model="officerPassword"
                        type="password"
                        :rules="officerPasswordRules"
                        required
                      ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        class="mx-auto mb-3"
                        type="submit"
                        color="primary"
                        variant="flat"
                        elevation="2"
                        :disabled="!officerValid"
                        @click="loginOfficer"
                      >
                        {{ $t("app_bar.login") }}
                      </v-btn>
                    </v-card-actions>
                  </v-form>-->
                </v-card>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-divider vertical v-show="$vuetify.display.mdAndUp"></v-divider>

        <v-col cols="12" md="6" :order="$vuetify.display.smAndDown ? 1 : ''">
          <v-card max-width="500" class="mx-auto fill-height">
            <v-card-title class="text-center mt-3">
              {{ $t("login.guidance") }}
            </v-card-title>
            <v-card-text>
              <h1 class="pb-5" align="center">
                {{ $t("login.guidance_title") }}
              </h1>
              <p class="pb-5" align="justify" style="text-indent: 50px">
                {{ $t("login.guidance_text") }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import UserProvider from "@/services/user.provider.js";
import UserCentralProvider from "@/services/user.central.provider.js";

const userProvider = new UserProvider();
const userCentralProvider = new UserCentralProvider();

export default {
  name: "LoginView",

  data: () => ({
    loading: false,

    valid: false,
    username: "",
    usernameRules: [
      (v) => !!v || "Register/Apply ID is required",
      (v) => /^\d+$/.test(v) || "Register ID must be valid",
    ],
    password: "",
    passwordRules: [
      (v) => !!v || "Password is required",
      (v) => v.length >= 8 || "Password must be 8 or more characters.",
    ],

    officerValid: false,
    officerEmail: "",
    officerEmailRules: [
      (v) => !!v || "E-mail is required",
      // (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    officerPassword: "",
    officerPasswordRules: [
      (v) => !!v || "Password is required",
      (v) => v.length >= 8 || "Password must be 8 or more characters.",
    ],

    googleAuthenUrl: "",

    error_message: "",
  }),

  computed: {
    is_dev_env() {
      if (process.env.VUE_APP_ENV !== "production") return true;
      return false;
    },

    is_authen() {
      return this.$store.state.user.is_authen;
    },

    is_authorized_officer() {
      return this.$store.state.user.is_authorized_officer;
    },
  },

  methods: {
    async login() {
      if (!this.valid) return;
      this.loading = true;
      const response = await userProvider
        .login(this.username, this.password)
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });
      if (response?.token) {
        sessionStorage.setItem("token", response.token);
        this.$store.dispatch("user/getUserInfo");
        this.$router.push("/").catch(() => {});
      }
      this.loading = false;
    },

    loginKeycloak() {
      this.$store.dispatch("keycloak/login");
    },

    async loginOfficer() {
      if (!this.officerValid) return;
      this.loading = true;
      const response = await userCentralProvider
        .loginJWT(this.officerEmail, this.officerPassword)
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });
      if (response?.token) {
        sessionStorage.setItem("token", response.token);
        this.$router.push("/").catch(() => {});
      }
      this.loading = false;
    },
  },

  created() {
    if (this.$store.state.user.is_authen) {
      this.$router.push("/").catch(() => {});
    }

    this.googleAuthenUrl = `https://accounts.google.com/o/oauth2/auth?
response_type=code&
access_type=online&
client_id=277499851660-krmerm1cop2o8c144dqg57d2f661r21p.apps.googleusercontent.com&
redirect_uri=https%3A%2F%2Fapi${
      process.env.VUE_APP_ENV == "development" ? "-dev" : ""
    }.reg.kmitl.ac.th%2Fuser%2F%3Ffunction%3Doauth%26service%3Dkmitl1&
state&
scope=email%20profile&
prompt=select_account`;
  },
};
</script>

<style lang="scss" scoped>
.card-box {
  max-width: 500px;
}

.separator {
  display: flex;
  align-items: center;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  color: rgb(180, 180, 180);
}

.separator::before,
.separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid rgb(235, 235, 235);
}

.separator::before {
  margin-right: 0.25em;
}

.separator::after {
  margin-left: 0.25em;
}

.google_logo {
  max-width: 22px;
}
</style>
